import { typeSize } from "@coaching-culture/ui";
import styled from "styled-components";
import { NextStepTone } from "./nextStep";

const stripColours = (tone: NextStepTone) =>
  tone === "calm"
    ? { bg: "grey6", text: "textMuted" }
    : { bg: `${tone}Soft`, text: `${tone}Text` };

/**
 * The next-step strip on team cards and the team member modal. Fixed height
 * (two lines of text) so every card's strip matches.
 */
export const Strip = styled.div<{ tone: NextStepTone }>`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 14px;
  height: 80px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 10px;
  background: ${(p) => p.theme.colors[stripColours(p.tone).bg]};

  & > button,
  & > span {
    flex-shrink: 0;
    align-self: center;
  }
`;

export const StripText = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const StripTag = styled.span<{ tone: NextStepTone }>`
  font-size: ${typeSize("caption")};
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(p) => p.theme.colors[stripColours(p.tone).text]};
`;

export const StripTitle = styled.span`
  font-size: ${typeSize("body")};
  font-weight: 600;
  line-height: 1.35;
  color: ${(p) => p.theme.colors.black};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
